const ROOT = document.documentElement;

const LEGIBLE_CLASS = "incluway-legible-font";
const LEGIBLE_STYLE_ID = "incluway-legible-font-style";

function ensureLegibleStyle() {
  if (document.getElementById(LEGIBLE_STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = LEGIBLE_STYLE_ID;

  style.textContent = `
    html.${LEGIBLE_CLASS} :not(.incluway-excluded):not(.incluway-excluded *)
      :not(#widget-container):not(#widget-container *)
      :not(#reactWidgetIframe):not(#reactWidgetIframe *) {
      font-family: Arial, Helvetica, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif !important;
    }
  `.trim();

  document.head.appendChild(style);
}

export function enableLegibleFont() {
  ROOT.classList.remove("incluway-dyslexic-font");

  document.getElementById("incluway-dyslexic-font-style")?.remove();
  document.getElementById("incluway-dyslexic-font-link")?.remove();

  ensureLegibleStyle();
  ROOT.classList.add(LEGIBLE_CLASS);
}

export function disableLegibleFont() {
  ROOT.classList.remove(LEGIBLE_CLASS);
}
